/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

export const RequestMethod = {
    Get: "GET",
    Patch: "PATCH",
    Post: "POST",
    Put: "PUT",
    Delete: "DELETE"
};
